import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const node = document.querySelector('[data-pajama-cart-config]');
const config = node ? JSON.parse(node.textContent) : {root:'/',products:[],gifts:[]};
const productIds = new Set(config.products.map(String));
const giftIds = new Set(config.gifts.map(String));
// The layout URL and a relative module import can have different asset query strings.
// Share the queue and install listeners once even if both module URLs are loaded.
const stateKey=Symbol.for('yumi.pajama.cart');
const state=window[stateKey] ||= {queue:Promise.resolve(),replaying:false,quantityWait:Promise.resolve(),installed:false};

export const isPajamaLine = line => productIds.has(String(line.product_id)) && ['base','byob'].includes(line.properties?._yumi_pajama_offer);
export const isPajamaGift = line => giftIds.has(String(line.variant_id)) && line.properties?._yumi_pajama_gift === '1';
export const giftLimit = count => count >= 5 ? 2 : count >= 4 ? 1 : 0;

export async function readPajamaCart() {
  const response = await fetch(config.root+'cart.js',{credentials:'same-origin',cache:'no-store'});
  if (!response.ok) throw Error('Please review your bag before continuing.');
  return response.json();
}

export function giftUpdates(cart) {
  const count=cart.items.filter(i=>isPajamaLine(i)&&i.properties._yumi_pajama_offer==='byob').reduce((n,i)=>n+i.quantity,0);
  let remaining=giftLimit(count);
  const updates={};
  for(const line of cart.items.filter(isPajamaGift)) {
    const keep=Math.min(line.quantity,remaining); remaining-=keep;
    if(keep!==line.quantity)updates[line.key]=keep;
  }
  return updates;
}

export function cartSections() {
  return [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
}

export function settlePajamaGifts() {
  const task=state.queue.catch(()=>{}).then(async()=>{
    const cart=await readPajamaCart(),updates=giftUpdates(cart);
    if(!Object.keys(updates).length)return cart;
    const deferred=CartLinesUpdateEvent.createPromise(); deferred.promise.catch(()=>{});
    document.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[],promise:deferred.promise,detail:{source:'yumi-pajama-gifts'}}));
    try {
      const response=await fetch(config.root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,sections:cartSections().join(','),sections_url:location.pathname})});
      if(!response.ok)throw Error('Please review your bag before continuing.');
      const result=await response.json();
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(result),detail:{items:result.items,sections:result.sections,source:'yumi-pajama-gifts'}});
      return result;
    }catch(error){deferred.reject(error);throw error;}
  });
  state.queue=task;return task;
}

if(node&&!state.installed) {
  state.installed=true;
  document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
    if(event.detail?.source==='yumi-pajama-gifts')return;
    event.promise?.then(result=>{
      if(result.detail?.source==='yumi-pajama-gifts')return;
      return settlePajamaGifts();
    }).catch(()=>{});
  });
  document.addEventListener('quantity-selector:update',()=>{
    state.quantityWait=new Promise(resolve=>setTimeout(resolve,400));
  },{capture:true});
  const checkoutTarget=target=>target?.closest('button[name="checkout"],input[name="checkout"],a[href^="/checkout"],a[href*="/checkouts/"]');
  async function beforeCheckout(event,target,submit=false) {
    if(state.replaying)return;
    event.preventDefault();event.stopImmediatePropagation();
    try {
      await state.quantityWait;
      await Promise.all(customElements.get('cart-items-component')?.pendingQuantityUpdates||[]);
      await settlePajamaGifts();
      state.replaying=true;
      if(submit)event.target.requestSubmit(event.submitter||undefined);
      else if(target.form)target.form.requestSubmit(target);
      else target.click();
    }catch {
      location.assign(config.root+'cart');
    }finally{state.replaying=false;}
  }
  document.addEventListener('click',event=>{const target=checkoutTarget(event.target);if(target)beforeCheckout(event,target);},{capture:true});
  document.addEventListener('submit',event=>{if(event.submitter?.name==='checkout')beforeCheckout(event,event.submitter,true);},{capture:true});
  settlePajamaGifts().catch(()=>{});
}
